var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "page-wrapper",
      attrs: { "element-loading-text": "登录中..." }
    },
    [
      _c("swb-login-head", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c("div", { staticClass: "login-wrapper retail" }, [
        _c("div", { staticClass: "logreg-banner", attrs: { id: "login" } }, [
          _c("div", { staticClass: "logreg-form login-fixed" }, [
            _c("h2", { staticClass: "title" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.switchLoginWay("acctpswd")
                    }
                  }
                },
                [_vm._v("账号登录")]
              ),
              _vm._v(" | "),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.switchLoginWay("scancode")
                    }
                  }
                },
                [_vm._v("扫码登录")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: this.loginWay == "acctpswd",
                    expression: "this.loginWay == 'acctpswd'"
                  }
                ]
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "user",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.user, rules: _vm.rules },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        _vm.submitForm("user")
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "form-row login mb20" }, [
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "phoneNo" } },
                            [
                              _c("label", { staticClass: "group-laber" }, [
                                _c("i", {
                                  staticClass:
                                    "icon iconfont icon-wode_zhanghao_dengluming font18"
                                })
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "font14",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入手机号码",
                                  "auto-complete": "off"
                                },
                                model: {
                                  value: _vm.user.phoneNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "phoneNo", $$v)
                                  },
                                  expression: "user.phoneNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row login mb20" }, [
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "password" } },
                            [
                              _c("label", { staticClass: "group-laber" }, [
                                _c("i", {
                                  staticClass:
                                    "icon iconfont icon-denglu-mima font18"
                                })
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "font14",
                                attrs: {
                                  type: "password",
                                  placeholder: "密码",
                                  "auto-complete": "off"
                                },
                                model: {
                                  value: _vm.user.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "password", $$v)
                                  },
                                  expression: "user.password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row login mb20" }, [
                      _c("div", { staticClass: "form-value" }, [
                        _c("div", { staticClass: "fl" }, [
                          _c("label", [
                            _c("input", {
                              attrs: {
                                name: "papers",
                                type: "checkbox",
                                value: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml5" }, [
                              _vm._v("自动登录")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "swb-btn mb20",
                        staticStyle: { width: "100%" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.submitForm("user")
                          }
                        }
                      },
                      [_vm._v("登录")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: this.loginWay == "scancode",
                    expression: "this.loginWay == 'scancode'"
                  }
                ]
              },
              [
                _c("center", [
                  _c("div", { staticClass: "msg-hint" }, [
                    _c("div", { staticClass: "msg-warn" }, [
                      _vm._v(_vm._s(_vm.scancodeHintText))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.scancodeImgUrl,
                      alt: "正在获取登录授权码......",
                      width: "236",
                      height: "236"
                    }
                  })
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "coagent" }, [
              _c("div", { staticClass: "fl" }, [
                _c("span", [_vm._v("忘记密码？")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "app-url",
                        rawName: "v-app-url",
                        value: "/user/pass/reset/jsp",
                        expression: "'/user/pass/reset/jsp'"
                      }
                    ],
                    staticClass: "swb-btn swb-btn-link"
                  },
                  [_vm._v("重置密码")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "regist-link" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "app-url",
                        rawName: "v-app-url",
                        value: "/user/regist/jsp",
                        expression: "'/user/regist/jsp'"
                      }
                    ],
                    staticClass: "swb-btn swb-btn-link"
                  },
                  [_vm._v("立即注册")]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("swb-login-foot")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-hint" }, [
      _c("div", { staticClass: "msg-warn" }, [
        _c("i", {
          staticClass: "icon iconfont icon-gantanhao11-copy hint-icon font-red"
        }),
        _vm._v(" 公共场所不建议自动登录，以防账号丢失 ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cc8e79a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc8e79a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/user/Login.vue
// module id = 4600
// module chunks = 0